// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2YBKr","rootCenter":"LoadMoreObserver_rootCenter__3LNNc","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1lfyw"};